export default {
  SET_PAYMENTS_SETTINGS: function (state, paymentSettings) {
    state.paymentSettings = paymentSettings;
  }
}
